var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.63764 8.32148C2.19598 7.76314 2.95326 7.44946 3.74287 7.44946H8.68328C9.4729 7.44946 10.2302 7.76314 10.7885 8.32148C11.3469 8.87982 11.6605 9.63709 11.6605 10.4267V11.6618C11.6605 11.9418 11.4335 12.1689 11.1535 12.1689C10.8735 12.1689 10.6464 11.9418 10.6464 11.6618V10.4267C10.6464 9.90605 10.4396 9.40671 10.0714 9.03854C9.70328 8.67038 9.20394 8.46355 8.68328 8.46355H3.74287C3.22221 8.46355 2.72287 8.67038 2.35471 9.03854C1.98654 9.40671 1.77971 9.90605 1.77971 10.4267V11.6618C1.77971 11.9418 1.5527 12.1689 1.27267 12.1689C0.992635 12.1689 0.765625 11.9418 0.765625 11.6618V10.4267C0.765625 9.63709 1.0793 8.87982 1.63764 8.32148Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21162 1.18279C5.1274 1.18279 4.24846 2.06172 4.24846 3.14595C4.24846 4.23017 5.1274 5.10911 6.21162 5.10911C7.29585 5.10911 8.17478 4.23017 8.17478 3.14595C8.17478 2.06172 7.29585 1.18279 6.21162 1.18279ZM3.23438 3.14595C3.23438 1.50166 4.56733 0.168701 6.21162 0.168701C7.85591 0.168701 9.18887 1.50166 9.18887 3.14595C9.18887 4.79024 7.85591 6.1232 6.21162 6.1232C4.56733 6.1232 3.23438 4.79024 3.23438 3.14595Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.9d189a31170501c5c040110d0dab5b81.svg";
export { ForwardRef as ReactComponent };